//import ShopaholicCartAdd from '@lovata/shopaholic-cart/shopaholic-cart-add';


import '@src/js/framework-min';

$('.full').slick({
   infinite: false,
   focusOnSelect: true,
   dots: false,
   arrows: false,
   slidesToShow: 1,
   slidesToScroll: 2,
});
$('.dots').slick({
   infinite: false,
   focusOnSelect: true,
   dots: false,
   arrows: false,
   asNavFor: '.full',
   slidesToShow: 3,
   slidesToScroll: 1,
});


$('.quan input').on('keyup', function () {
   $(this).val($(this).val().replace(/[^0-9]/g, ''));
});
$('.quan .plus').click(function () {
   var i = $(this).siblings('input').val();
   i++;
   $(this).siblings('input').val(i);
});
$('.quan .minus').click(function () {
   var i = $(this).siblings('input').val();

   if (i > 1) {
      i--;
      $(this).siblings('input').val(i);
   }
});


//import ShopaholicCartPosition from "@lovata/shopaholic-cart/shopaholic-cart-position";
//import ShopaholicCart from "@lovata/shopaholic-cart/shopaholic-cart";
//import ShopaholicCartShippingType from "@lovata/shopaholic-cart/shopaholic-cart-shipping-type";

export default new class ProductInfo {
   constructor() {
      //this.detailSelector = 'product-info__detail-btn';
      //this.detailOpenSelector = 'product-info__detail-btn_open';
      //this.textSelector = 'product-info__detail-text';
      //this.textHiddenSelector = 'product-info__detail-text_visually-hidden';
      //this.sMiniCartWrapper = '_shopaholic-cart-mini-wrapper';
      //this.preLoaderClass = 'product-info__preloader';
      this.wrapperSelector = 'product';
      //this.tooltipSelector = 'product-info__tooltip';
      //this.tooltipVisibleSelector = 'product-info__tooltip_visible';
      this.filterPrintLabel = 'print-radio';
      this.filterPrintWrapper = 'wrapper-select-print';
      this.filterColorLabel = '#color';
      this.filterColorWrapper = 'wrapper-select-colors';
      this.filterSizeLabel = '#size';
      this.filterSizeWrapper = 'wrapper-select-sizes';
      this.classErrorFilter = 'no-select';
      this.classBtnBuy = 'product-btn-buy';
      
      //this.obShopaholicCartAdd = new ShopaholicCartAdd();

      //ShopaholicCart.instance();
      this.handler();
      this.goBuyProduct();
      this.selectPrint();
      this.selectColor();
      this.selectSize();
   }

   handler() {

   }

   selectColor() {
      $(`${this.filterColorLabel}`).on('change', ({ target }) => {
         const inputColor = $(target).find('option:selected');
         if (inputColor.is(':not(:disabled)')) {
            this.warningSelectField(this.filterColorWrapper, false);
            this.setNewPrice($(inputColor).val());
         }
      });
   }

   selectPrint() {
      $(`.${this.filterPrintLabel}`).on('change', ({ target }) => {
         const inputPrint = $(target);
         if (inputPrint.is(':not(:disabled)')) {
            const offersId = inputPrint.val();

            const sizeId = inputPrint.attr('size');
            this.setActualSize(offersId, sizeId);
         }
      });
   }


   selectSize() { 
      $(`${this.filterSizeLabel}`).on('change', ({ target }) => {
         const inputSize = $(target).find('option:selected');
         if (inputSize.is(':not(:disabled)')) {
            let offersId = inputSize.val();
            let sizeId = inputSize.attr('print');
            this.setActualPrint(offersId, sizeId);
            this.checkSelectOptions(inputSize);
            this.warningSelectField(this.filterSizeWrapper, false);
         }
      });
   }

   setActualSize(offerId, sizeId) {
      const sizeArray = sizeId.split(',');

      const sizeInput = $(`${this.filterSizeLabel} option:not(.defaut)`);

      sizeInput.attr('disabled', 'disabled');
      sizeInput.prop('selected', '');
      

      $.each($(`${this.filterSizeLabel} option` ), (key, value) => {
         let sizeValue = $(value).text();
      
         $.each(sizeArray, (keys, valueSize) => {
            if (sizeValue === valueSize) {
               $(value).removeAttr('disabled');
               this.warningSelectField(this.filterPrintWrapper, false);
            }
         });
      });
   }


   setActualPrint(offerId, printId) {
      const printArray = printId.split(',');
      const printInput = $(`.${this.filterPrintLabel} input`);

      printInput.attr('disabled', 'disabled');
      printInput.removeAttr('checked');

      $.each($(`.${this.filterPrintLabel} input`), (key, value) => {
  
         let printValue = $(value).attr('print');
         
         $.each(printArray, (keys, valuePrint) => {
          
            if (printValue === valuePrint) {
               $(value).removeAttr('disabled');
               $(value).attr('checked', true);
               //this.warningSelectField(this.filterPrintWrapper, false);
            }
         });
      });
   }

   checkSelectOptions(sizeArr) {
      const printSelect = $(`.${this.filterPrintLabel}`).children('input:checked').val();
      const sizeSelect = $(`${this.filterSizeLabel}`).val();
      const colorSelect = $(`${this.filterColorLabel}`).val();
      let isOk = false;
      if (!sizeArr) {
         if (!printSelect) {
            this.warningSelectField(this.filterPrintWrapper, true);
         }
         if (!sizeSelect || sizeSelect == 0) {
            this.warningSelectField(this.filterSizeWrapper, true);
         }
         if (!colorSelect || colorSelect == 0) {
            this.warningSelectField(this.filterColorWrapper, true);
         } else {
            $(`.${this.classBtnBuy}`).attr('offer_id', colorSelect);
            isOk = true;
         }
         if (!colorSelect && !sizeSelect && !printSelect) {
            isOk = true;
         }
      }

      if ((printSelect && sizeSelect != 0) || (printSelect && sizeArr)) {
         const printSelectArr = printSelect.split(',');
         const sizeSelectArr = (sizeArr) ? sizeArr.val() : sizeSelect;
         const offerId = printSelectArr.filter(obj => sizeSelectArr.split(',').indexOf(obj) >= 0);
         $(`.${this.classBtnBuy}`).attr('offer_id', offerId[0]);
     
         this.setNewPrice(offerId[0]);
         isOk = true;
      }
      return isOk;
   }

   setNewPrice(offer_id) {
      let obData = {
         update: { 'product/product-price': '.wrapper-price' },
         data: {
            'offer_id': offer_id
         }
      };
      $.request('onAjax', obData);
   }

   warningSelectField(field, isError) {
      if (isError) {
         $(`.${field}`).addClass(this.classErrorFilter);
      } else {
         $(`.${field}`).removeClass(this.classErrorFilter);
      }
   }

   goBuyProduct() {
      $(`.${this.classBtnBuy}`).on('click', (e) => {
         let btnBuy = $(`.${this.classBtnBuy}`);
         let countItem = $('.quan input').val();
         let checkFieldValue = this.checkSelectOptions();
         let offerId = $(`.${this.classBtnBuy}`).attr('offer_id');
         if (checkFieldValue) {
            btnBuy.attr('disabled', 'true');
            let checkoutUrl = $(btnBuy).attr('next-url');
            this.addCart(offerId, countItem, checkoutUrl);
         }
      });
   }

   addCart(offer_id, count, checkoutUrl) {
      let data = {
         'cart': [
            { 'offer_id': offer_id, 'quantity': count }
         ],
         'shipping_type_id': 1,
         'payment_method_id': 1
      };

      $.request('Cart::onAdd', {
         'data': data,
         'complete': setTimeout(() => { window.location = checkoutUrl }, 1000) 
      });
   }

   
}();

